import { useEffect, useState } from "react";

const SplashScreen = () => {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("cb_splash_done");
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!visible) return;
    // Start fade-out at 550ms so total splash time ≈ 900ms
    const hideTimer = setTimeout(() => setLeaving(true), 550);
    const removeTimer = setTimeout(() => {
      setVisible(false);
      try {
        sessionStorage.setItem("cb_splash_done", "1");
      } catch (e) {
        // ignore
      }
    }, 950);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center overflow-hidden ${
        leaving ? "splash-leaving" : ""
      }`}
    >
      <div className="grid-bg absolute inset-0 opacity-30" aria-hidden />

      <div className="relative flex items-center gap-4 lg:gap-6 h-16 lg:h-20 splash-brand">
        <img
          src="/logo.svg"
          alt="Conveyor Belts S.R.L."
          className="h-full w-auto object-contain splash-logo"
        />
        <span className="font-display uppercase tracking-tight text-white leading-none text-[2.5rem] lg:text-[3.25rem] whitespace-nowrap splash-text">
          Conveyor Belts <span className="text-white/50">S.R.L.</span>
        </span>
      </div>

      {/* Bottom hazard stripe reveal */}
      <span
        aria-hidden
        className="absolute bottom-0 left-0 h-1.5 stripe-bg splash-stripe"
      />
    </div>
  );
};

export default SplashScreen;
